import React, { useEffect } from "react";
import { Container, } from "react-bootstrap";
import { connect } from "react-redux";
import MaterialSize from "material-table";
import { getExpensetypeApi, deleteExpenseTypeApi, updateExpenseTypeApi } from "./Expense.action";
import { baseURL, headers } from "../../../../../global/api";
import { setHeading } from "../../../accounts/account.actions";


const ViewExpenseType = (props) => {

  useEffect(() => {
    props.setHeading("Expense Type List");
  }, []);

  return (
    <>
      <Container fluid>
        <MaterialSize
          title="Expense Type list"
          columns={[
            { title: "Expense Name", field: "expenseName" },
            { title: "Expense Description", field: "expenseDesc" },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = `${baseURL}/expenseType?`;
              url += "limit=" + query.pageSize;
              url += "&page=" + (query.page);
              url += "&search=" + query.search;
              fetch(url, {
                method: "GET",
                headers: headers,
              }).then((response) => response.json()).then((result) => {
                resolve({
                  data: result.data,
                  page: result.page,
                  totalCount: result.total_results,
                });
              });
            })
          }
          options={{
            actionsColumnIndex: -1,
            // filtering: true,
            exportButton: true,
            exportAllData: true,
            paging: true,
            pageSize: 50,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [30, 50, 100, 150, 200],
            headerStyle: {
              position: "sticky",
              top: 0,
              color: "#00BBBB",
              fontWeight: "550",
              onRowAdd: "none",
            },
          }}
          editable={{
            onRowUpdate: (newData, oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.updateExpenseTypeApi(newData, oldData);
                }, 600);
              }),
            onRowDelete: (oldData) =>
              new Promise((resolve) => {
                setTimeout(() => {
                  resolve();
                  props.deleteExpenseTypeApi(oldData._id);
                }, 600);
              }),
          }}
        />
      </Container>
    </>
  );
};
const mapDispatchToProps = (dispatch) => {
  return {
    getExpensetypeApi: () => dispatch(getExpensetypeApi()),
    deleteExpenseTypeApi: (id) => dispatch(deleteExpenseTypeApi(id)),
    updateExpenseTypeApi: (newData, oldData) => dispatch(updateExpenseTypeApi(newData, oldData)),
    setHeading: (data) => dispatch(setHeading(data)),
  };
};
const mapStateToProps = (state, ownProps) => ({
  expenseTypeDataList: state.ExpenseTypeReducer.expenseTypeDataList,
  isFetchingExpenseType: state.ExpenseTypeReducer.isFetchingExpenseType,
});

export default connect(mapStateToProps, mapDispatchToProps)(ViewExpenseType);
